export default [{
    path: '/order/submit/:id',
    name: '确定订单',
    component: () => import('@/views/order/Confirm'),
    meta: { breadNumber: 2 }
}];
